import React, { useEffect, useState } from 'react';
import { usePropertyStructureType } from '../../../../../queries/PropertyFields/TopLevelFields';
import {
    usePropertyRentalNumberUnits,
    usePropertyRentalProvideUnitsLater,
} from '../../../../../queries/PropertyFields/RentalUnitsFields';
import { ShowIf } from '../../../../components/ShowIf';
import * as Store from '@apply/store';
import { UnitInformation } from './components/UnitInformation/UnitInformation';
import { rentalStructureTypes } from '../../constants/rentalStructureTypes';
import { ProvideRentalUnitsLater } from './components/ProvideRentalUnitsLater';
import { RentalUnitsDropDown } from './components/RentalUnitsDropDown';
import { RentalIncomeRestrictedUnitsDropDown } from './components/RentalIncomeRestrictedUnitsDropDown';

export interface RentalUnitsProps {
    header?: string;
    units?: Store.PropertiesStore.Types.RentalUnit[];
    propertyGuid: string;
    provideRentalUnitsLater?: boolean;
    includeOccupied: boolean;
    isReview?: boolean;
}

export const RentalUnits: React.FC<RentalUnitsProps> = ({
    propertyGuid,
    header = 'Unit Information',
    includeOccupied,
    isReview = false,
}) => {
    const [fivePlusUnitsSelected, set_fivePlusUnitsSelected] = useState<boolean>(false);
    const [unitsPerStructure, set_unitsPerStructure] = useState<number>(0);

    const [numberRentalUnits] = usePropertyRentalNumberUnits(propertyGuid);
    const [provideRentalUnitsLater] = usePropertyRentalProvideUnitsLater(propertyGuid);
    const [rentalStructureType] = usePropertyStructureType(propertyGuid);

    const rentalStructureTypeValue = rentalStructureTypes?.find((val) => val.display === rentalStructureType)?.value as string;

    useEffect(() => {
        if (rentalStructureTypeValue !== '6') set_fivePlusUnitsSelected(false);
        switch (rentalStructureTypeValue) {
            case '1':
            case '2':
            case '7':
                set_unitsPerStructure(1);
                break;
            case '3':
                set_unitsPerStructure(2);
                break;
            case '4':
                set_unitsPerStructure(3);
                break;
            case '5':
                set_unitsPerStructure(4);
                break;
            case '6':
                set_unitsPerStructure(5);
                set_fivePlusUnitsSelected(true);
                break;
            default:
                return;
        }
    }, [rentalStructureTypeValue]);

    return (
        <>
            <div>
                {fivePlusUnitsSelected && (
                    <RentalUnitsDropDown
                        propertyGuid={propertyGuid}
                        isReview={isReview}
                    />
                )}
                {fivePlusUnitsSelected && numberRentalUnits != undefined && (
                    <RentalIncomeRestrictedUnitsDropDown
                        propertyGuid={propertyGuid}
                        numberOfUnits={numberRentalUnits}
                        isReview={isReview}
                    />
                )}
                {fivePlusUnitsSelected && numberRentalUnits != undefined && numberRentalUnits >= 35 && (
                    <div>
                        <ProvideRentalUnitsLater
                            propertyGuid={propertyGuid}
                            isReview={isReview}
                        />
                    </div>
                )}
            </div>
            <ShowIf showIf={!provideRentalUnitsLater}>
                <div
                    className='pageSubHeader'
                    style={{ padding: '20px 0 20px 0' }}
                >
                    {header}
                </div>
                <UnitInformation
                    propertyGuid={propertyGuid}
                    type={rentalStructureTypeValue}
                    unitInformationRows={numberRentalUnits ? numberRentalUnits : unitsPerStructure}
                    includeOccupied={includeOccupied}
                    isReview={isReview}
                />
            </ShowIf>
        </>
    );
};
